module.exports = __webpack_public_path__ + "static/img/82-3.f9073a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/82-3.jpg
// module id = M/b7
// module chunks = 0